import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  HostListener
} from '@angular/core';

@Component({
  selector: 'awair-add-toggle',
  templateUrl: './add-toggle.component.html',
  styleUrls: ['./add-toggle.component.scss']
})

export class AddToggleComponent implements OnInit {
  @HostListener('click') click() {
    this.onToggle(this.isAdded);
  }
  @Input() isAdded: boolean = false;
  @Output() toggle: EventEmitter<boolean> = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  onToggle(isAdded: boolean) {
    this.isAdded = !isAdded;
    this.toggle.emit(this.isAdded);
  }
}
